import {
  SECTIONS_REQUEST,
  SECTIONS_LOADING,
  SECTIONS_SUCCESS,
  SECTIONS_ERROR,
  CALCULATE_PROGRESS,
  COMPLETE_HOME_SECTION,
  COMPLETE_HOME_SECTION_SUCCESS,
  STATES_REQUEST,
  STATES_SUCCESS,
  ZIP_CODES_REQUEST,
  ZIP_LOADING,
  ZIP_SUCCESS,
  ZIP_ERROR,
  SET_IS_APP_ACCESS_PAID,
  SET_APP_ACCESS_TYPE,
  FETCH_PAYMENT_TOKEN,
  POST_PAYMENT_SUCCESS,
  FETCH_APP_PRODUCTS,
  SET_APP_PRODUCTS,
  FETCH_ORDERS,
  SET_ORDERS,
  GET_FORM_PROGRESS,
  SET_PERSONAL_EDIT_LIMIT,
  SET_ADDRESS_EDIT_LIMIT,
  FETCH_USER_APP,
  USER_APP_ACCESS_ERROR,
  USER_APP_ACCESS_SUCCESS,
  SET_IS_APP_CLOSED,
} from '@/app/main/store/types';

import { http } from '@/api';
import {
  LOGOUT, REFRESH_REQUEST, SET_USER_ID, SET_CPA_ID,
} from '@/app/auth/store/types';
import {
  ADDRESS_ERROR,
  ADDRESS_LOADING,
} from '@/app/personal/store/types';
import { SET_FILING_DECISION } from '@/app/file/store/types';

export const actions = {
  [SECTIONS_REQUEST]: ({ commit, dispatch, getters }, appId) => new Promise(((resolve, reject) => {
    commit(SECTIONS_LOADING);

    const token = localStorage.getItem('user-token');
    if (token) {
      http.get('/auth/me', {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((resp) => {
          if (resp.data.currentUserApplication === null) {
            dispatch(FETCH_USER_APP, appId || getters.getUserId)
              .then((result) => {
                resolve({ ...resp, currentUserApplication: result });
              })
              .catch((error) => {
                if (error.response.status === 403) {
                  reject(error);
                }
              });
          } else {
            const userId = getters.getUserId;
            const { filingType } = resp.data.currentUserApplication;
            commit(SECTIONS_SUCCESS, resp.data.currentUserApplication);
            commit(SET_APP_ACCESS_TYPE, {
              appAccessType: resp.data.currentUserApplication.appAccessType,
            });
            commit(SET_PERSONAL_EDIT_LIMIT, resp.data.currentUserApplication);
            commit(SET_ADDRESS_EDIT_LIMIT, resp.data.currentUserApplication);
            commit(SET_FILING_DECISION, filingType);
            commit(SET_IS_APP_ACCESS_PAID, resp.data.currentUserApplication.isAppAccessPaid);
            commit(SET_IS_APP_CLOSED, resp.data.currentUserApplication.isClosed);
            dispatch(GET_FORM_PROGRESS, userId);
            resolve(resp);
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(REFRESH_REQUEST).then(() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            });
          } else {
            commit(SECTIONS_ERROR, err);
            dispatch(LOGOUT);
          }
        });
    }
  })),
  [COMPLETE_HOME_SECTION]: ({ commit, getters }) => new Promise(((resolve, reject) => {
    const userId = getters.getUserId;
    commit(SECTIONS_LOADING);
    http.put(`/home/apps/${userId}/complete-section`)
      .then((resp) => {
        commit(COMPLETE_HOME_SECTION_SUCCESS);
        resolve(resp);
      })
      .catch((err) => {
        commit(SECTIONS_ERROR, err);
        reject(err);
      });
  })),
  [STATES_REQUEST]: ({ commit }) => new Promise(((resolve, reject) => {
    commit(ADDRESS_LOADING);
    http.get('/lookup/state')
      .then((resp) => {
        commit(STATES_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(ADDRESS_ERROR);
        reject(err);
      });
  })),
  [ZIP_CODES_REQUEST]: ({ commit }, zip) => new Promise(((resolve, reject) => {
    commit(ZIP_LOADING);
    http.get(`/lookup/zip-details/${zip}`)
      .then((resp) => {
        commit(ZIP_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(ZIP_ERROR);
        reject(err);
      });
  })),
  [FETCH_PAYMENT_TOKEN]: () => new Promise((resolve, reject) => {
    http.get('/purchases/token')
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [POST_PAYMENT_SUCCESS]: ({ commit }, data) => new Promise((resolve, reject) => {
    http.post(`/purchases/apps/${data.userId}/buy/${data.productId}`, data.body)
      .then((resp) => {
        commit(SET_IS_APP_ACCESS_PAID, true);
        commit(SET_APP_ACCESS_TYPE, { appAccessType: data.accessType });
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [FETCH_APP_PRODUCTS]: ({ commit }, userId) => new Promise((resolve, reject) => {
    http.get(`/purchases/apps/${userId}/products`)
      .then((resp) => {
        commit(SET_APP_PRODUCTS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [FETCH_ORDERS]: ({ commit }, userId) => new Promise((resolve, reject) => {
    http.get(`/purchases/apps/${userId}/orders`)
      .then((resp) => {
        commit(SET_ORDERS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [GET_FORM_PROGRESS]: ({ commit }, userId) => new Promise((resolve, reject) => {
    http.get(`/form/apps/${userId}/progress`)
      .then((resp) => {
        commit(CALCULATE_PROGRESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  // eslint-disable-next-line no-empty-pattern
  [FETCH_USER_APP]: ({ commit, dispatch }, appId) => new Promise(((resolve, reject) => {
    if (appId != null) {
      http.get(`/auth/apps/${appId}`)
        .then((resp) => {
          commit(USER_APP_ACCESS_SUCCESS);
          commit(SECTIONS_SUCCESS, resp.data);
          commit(SET_APP_ACCESS_TYPE, { appAccessType: resp.data.appAccessType });
          commit(SET_PERSONAL_EDIT_LIMIT, resp.data);
          commit(SET_ADDRESS_EDIT_LIMIT, resp.data);
          commit(SET_FILING_DECISION, resp.data.filingType);
          commit(SET_IS_APP_ACCESS_PAID, resp.data.isAppAccessPaid);
          commit(SET_IS_APP_CLOSED, resp.data.isClosed);
          commit(SET_USER_ID, resp.data.id);
          commit(SET_CPA_ID, resp.data.id);
          dispatch(GET_FORM_PROGRESS, resp.data.id);
          resolve(resp.data);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 403) {
            commit(USER_APP_ACCESS_ERROR);
          }
          reject(err);
        });
    }
  })),
};
